import type { ReactNode } from 'react'
import { PERSONAS } from '../lib/personas'
import BrandMark from './BrandMark'

const FLOW = ['Ideias', 'Análise', 'Decisões', 'SDD', 'Diagramas', 'Event Storm', 'Protótipo']

export default function AuthSplit({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-canvas text-ink">
      <div className="bg-surface flex flex-col px-6 sm:px-10 py-7 min-h-screen">
        <div className="flex items-center gap-2">
          <BrandMark size={26} />
          <span className="font-semibold">ArchForge</span>
        </div>
        <div className="flex-1 flex items-center justify-center py-10">
          <div className="w-full max-w-[380px]">{children}</div>
        </div>
        <div className="font-mono text-[11px] text-faint">Seu time de arquitetura, na mesma sala.</div>
      </div>
      <aside className="hidden lg:flex flex-col justify-between bg-[#eceae4] dark:bg-[#14151a] px-12 py-10">
        <div>
          <p className="font-mono text-[11px] uppercase tracking-wide text-muted m-0">Seu time de arquitetura</p>
          <h2 className="mt-3 text-[28px] leading-tight font-semibold m-0 max-w-md">
            Quatro agentes levam a ideia até a documentação.
          </h2>
        </div>
        <div className="grid grid-cols-2 gap-3">
          {PERSONAS.map((persona) => (
            <div key={persona.id} className="bg-surface border border-line rounded-xl p-3.5">
              <div className="w-8 h-8 rounded-lg text-white flex items-center justify-center" style={{ background: persona.color }}>
                <persona.icon size={16} />
              </div>
              <div className="mt-3 font-semibold text-sm">{persona.name}</div>
              <div className="text-xs text-muted mt-0.5">{persona.role}</div>
              <div className="text-xs text-ink/80 mt-2 leading-relaxed">{persona.produces}</div>
            </div>
          ))}
        </div>
        <div className="flex flex-wrap items-center gap-1.5 font-mono text-[11px] text-muted">
          {FLOW.map((step, index) => (
            <span key={step} className="inline-flex items-center gap-1.5">
              {index > 0 && <span className="text-faint">→</span>}
              {step}
            </span>
          ))}
        </div>
      </aside>
    </div>
  )
}
